import { trackByIndex } from 'src/app/shared/utils/track-by.util';
import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import {
    MonitoringSiteObservationDto,
    MonitoringSiteObservationModel,
} from "src/app/models/monitoringSiteObservation.model";

import { AirNowService } from "src/app/services/airNow.service";
import { MatDialog } from "@angular/material/dialog";
import { SensorService } from "src/app/services/sensor.service";
import { ToastService } from "src/app/services/toast.service";
import { NodeAssignmentDialogComponent } from "src/app/modals/node-assignment-dialog/node-assignment-dialog.component";

@Component({
  standalone: false,
    selector: "app-info-window",
    templateUrl: "./info-window.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./info-window.component.scss"],
})
export class InfoWindowComponent implements OnInit {
    @Input() siteId: string;
    @Input() latitude: number;
    @Input() longitude: number;

    observations: MonitoringSiteObservationModel[];
    observation: MonitoringSiteObservationModel;
    isFormLoading = false;
    isLoading = false;

    constructor(
        private airNowService: AirNowService,
        private sensorService: SensorService,
        private dialog: MatDialog,
        private toastService: ToastService,
    ) {}

    ngOnInit(): void {
        const payload = new MonitoringSiteObservationDto([
            this.longitude - 0.01,
            this.latitude - 0.01,
            this.longitude + 0.01,
            this.latitude + 0.01,
        ]);
        this.isFormLoading = true;
        this.airNowService.getObservationsByMonitoringSite(payload).subscribe(
            (result) => {
                const observations = result.filter(
                    (x) => x.intlAQSCode === this.siteId,
                );
                if (observations.length > 0) {
                    this.observation = observations[0];
                }
                this.observations = observations;
                this.isFormLoading = false;
            },
            (error) => {
                this.toastService.showError(error);
                this.isFormLoading = false;
            },
        );
    }

    assign() {
        this.isLoading = true;
        this.sensorService
            .getOrCreateSensorByAirNowSiteId(this.siteId)
            .subscribe(
                (sensor) => {
                    this.dialog.open(NodeAssignmentDialogComponent, {
                        data: {
                            sensorId: sensor.id,
                            sensorName: sensor.name,
                        },
                        width: "450px",
                        disableClose: true,
                    });
                    this.isLoading = false;
                },
                (error) => {
                    this.toastService.showError(error);
                    this.isLoading = false;
                },
            );
    }

    public trackByIndex = trackByIndex;
}
